import { handleActions } from 'redux-actions'
import update from 'immutability-helper'
import * as actions from './lbsCircle.actions'
import { ActionType } from './type'
const initialState = {
	offlineList: {
        data: [] as any[],
        page: 1,
        pageSize: 10,
        totalNumber: 0
    },
    checkTheNumberReq: {} as object,
    saveSearchVal: '',
    previewList: [] as any[],
    batchUploadState: {
        code: 1,
        message: ''
    } as any, 
    activeNumberAll: 0,
    activeNumber0: 0,
    activeNumber1: 0,
    activeNumber2: 0,
    activeNumber3: 0,
    activeNumber4: 0,
    activeNumber5: 0,
    activeNumber6: 0,
    activeNumber7: 0,
    activeNumber8: 0,
    activeNumber9: 0,

    //// old 
    //// ----------------------
    //// new
    searchCurrentCity: '全国' as string,
    searchKeyWord: '',
    searchLoading: false,
    localSearchInstance: null as any,
    searchResult: {
        cityList: [],
        list: [],
        total: 10,
        current: 0,
        pageSize: actions.PAGE_SIZE
    } as any,
    // 预估人数
    searchPointPredict: new Map() as Map<number, number>, // <点, 人数>
    selectedList: [] as any[],
    currentSelectPoint: null as any

}

export type LbsCircleState = typeof initialState


function setState<T> (state:LbsCircleState, field: string, value: T): LbsCircleState {
    if (!state.hasOwnProperty(field)) {
        console.error(`modules-lbsCircle-reducer[ERROR]: can't find ${field} property in LbsCircleState`)
    }
    return update(state, { [field]: { $set: value } })
}


export default handleActions<LbsCircleState>({
    [actions.RECEIVE_OFFLINE_LIST]: (state: any, { payload }) => {
        return update(state, {
            offlineList: { 
                $set: (payload as any) 
            },
        })
    },
    [actions.SAVE_CHECK_THE_NUMBER_REQ]: (state: any, { payload }) => {
        return update(state, {
            checkTheNumberReq: { 
                $set: (payload as any) 
            },
        })
    },
    [actions.RECEIVE_SEARCH_VAL]: (state: any, { payload }) => {
        return update(state, {
            saveSearchVal: { 
                $set: (payload as any) 
            },
        })
    },
    [actions.RECEIVE_PREVIEW_LIST]: (state: any, { payload }) => {
        return update(state, {
            previewList: { 
                $set: (payload as any) 
            },
        })
    },
    [actions.RECEIVE_BATCH_UPLOAD]: (state: any, { payload }) => {
        return update(state, {
            batchUploadState: { 
                $set: (payload as any) 
            },
        })
    },
    [actions.RECEIVE_ACTIVE_NUMBER_ALL]: (state: any, { payload }) => {
        return update(state, {
            activeNumberAll: { 
                $set: (payload as any) 
            },
        })
    },
    [actions.RECEIVE_ACTIVE_NUMBER]: (state: any, { payload }) => {
        return update(state, {
            [(payload as any).name]: {
                $set : (payload as any).response
            },
            activeNumberAll: {
                $set : state.activeNumberAll + (payload as any).response
            }
        })
    },
    //// old 
    //// ----------------------
    //// new
    [ActionType.UPDATE_STATE] (state,  { payload }) {
        // console.log('reducer', payload)
        console.log('payload', payload)
        let s = state
        for (let key in payload) 
            s = setState(s, key, payload[key])
        
        return s
    },
}, initialState)
